import { ResourceProps } from "react-admin";
import Icon from "@mui/icons-material/NightShelter";
import { Resource } from "../../enums";
import ListScreen from "./list";
import { CreateScreen } from "./create";
import { EditScreen } from "./edit";

const amenities: ResourceProps = {
  name: Resource.AMENITIES,
  icon: Icon,
  list: ListScreen,
  create: CreateScreen,
  edit: EditScreen,
  options: {
    label: "Amenities",
  },
};

export default amenities;
